/**
 * Conversación directa con un agente (GEN-PX-011, spec §4.4 y §5.6). Solo con lo que
 * el front ya tiene (`descriptor.chats`): sin llamadas nuevas ni lógica de negocio.
 *
 * «Conversación con ese agente» = el chat cuyo INTERLOCUTOR es él: quien respondió el
 * último turno (`agente_ultimo.id`, GEN-195). Un kernel que aún no lo manda se resuelve
 * por `agentes_en_chat` solo si el agente es el ÚNICO que habló (un chat que Anne
 * reparte entre varios no es «con» ninguno de ellos). Y su última actividad
 * (`updated_at`) ha de ser de menos de 24 h.
 */

export const VENTANA_RETOMAR_MS = 24 * 60 * 60 * 1000

const esConversacionCon = (agent, chat) => {
  if (chat?.agente_ultimo?.id != null) return chat.agente_ultimo.id === agent.id
  const habla = chat?.agentes_en_chat ?? []
  return habla.length === 1 && habla[0]?.nombre === agent.nombre
}

/** chat_id de la conversación reciente con el agente (la de actividad más nueva), o null. */
export function conversacionReciente(agent, chats = [], ahora = Date.now()) {
  let mejor = null
  let mejorT = -Infinity
  for (const c of chats) {
    const t = Date.parse(c?.updated_at ?? '')
    if (!Number.isFinite(t) || ahora - t >= VENTANA_RETOMAR_MS || t > ahora + 60_000) continue
    if (!esConversacionCon(agent, c)) continue
    if (t > mejorT) { mejor = c.chat_id; mejorT = t }
  }
  return mejor
}
